import { c as _c } from "react/compiler-runtime";
import { useAtom } from "jotai";
import { Icon } from "@iconify/react";
import { batchSettings as defaultBatchSettings } from "../constants";
import { userBatchSettings } from "@/config/atoms";
import { ButtonOverride as Button } from "@/components/Buttons/ButtonOverride";
import { projTheme } from "@/constants/project-specific/theme/index";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Popover, PopoverContent, PopoverTrigger, useDisclosure, Input } from "@heroui/react";
import { customFont } from "@/constants/index";
import { cn } from "@/util/cn";

// const userBatchSettings = atomWithStorage('batchSettings', batchSettings)

export default function SettingsButton(props) {
  const $ = _c(27);
  const {
    isOpen: isSettingsOpen,
    onOpen: onSettingsOpen,
    onOpenChange: onSettingsOpenChange
  } = useDisclosure();
  const [batchSettings, setBatchSettings] = useAtom(userBatchSettings);
  let t0;
  if ($[0] !== setBatchSettings) {
    t0 = e => {
      let claimValue = {};
      if (Number.isInteger(Number(e.target.value)) && Number(e.target.value) > 0) {
        claimValue = {
          maxBatchClaim: e.target.value
        };
        setBatchSettings(batchSettings_0 => ({
          ...batchSettings_0,
          ...claimValue
        }));
      }
    };
    $[0] = setBatchSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClaimChange = t0;
  let t1;
  if ($[2] !== setBatchSettings) {
    t1 = e_0 => {
      let stakeValue = {};
      if (Number.isInteger(Number(e_0.target.value)) && Number(e_0.target.value) > 0) {
        stakeValue = {
          maxBatchStake: e_0.target.value
        };
        setBatchSettings(batchSettings_1 => ({
          ...batchSettings_1,
          ...stakeValue
        }));
      }
    };
    $[2] = setBatchSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleStakeChange = t1;
  let t2;
  if ($[4] !== setBatchSettings) {
    t2 = e_1 => {
      let stakeValue_0 = {};
      if (Number.isInteger(Number(e_1.target.value)) && Number(e_1.target.value) > 0) {
        stakeValue_0 = {
          maxBatchUnstake: e_1.target.value
        };
        setBatchSettings(batchSettings_2 => ({
          ...batchSettings_2,
          ...stakeValue_0
        }));
      }
    };
    $[4] = setBatchSettings;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleUnstakeChange = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon="material-symbols:settings" height="auto" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onSettingsOpen || $[8] !== props.className || $[9] !== props.size) {
    t4 = <Button color="success" onPress={onSettingsOpen} className={props.className} size={props.size} startContent={t3} aria-description="Staking User Settings">Settings</Button>;
    $[7] = onSettingsOpen;
    $[8] = props.className;
    $[9] = props.size;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("", customFont.className);
    t6 = {
      base: "cards-modal",
      header: "text-white bg-primary/30 rounded-t-2xl mb-0 py-3",
      body: "mt-3"
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] !== batchSettings.maxBatchClaim || $[14] !== batchSettings.maxBatchStake || $[15] !== batchSettings.maxBatchUnstake || $[16] !== handleClaimChange || $[17] !== handleStakeChange || $[18] !== handleUnstakeChange) {
    t7 = <ModalContent>{onClose => <><ModalHeader className="flex flex-col gap-1">User Settings</ModalHeader><ModalBody><div className="relative flex flex-col flex-1 items-center content-center"><div className="flex w-full flex-wrap md:flex-nowrap gap-4 mb-2"><Input key="claim" variant={projTheme.input?.defaultVariant ?? "bordered"} label="Max Claim Batch Size" labelPlacement="inside" type="number" description="Max number of NFTs to claim rewards on at once" value={String(batchSettings.maxBatchClaim ?? defaultBatchSettings.maxBatchClaim)} onChange={e_2 => handleClaimChange(e_2)} /></div><div className="flex w-full flex-wrap md:flex-nowrap gap-4"><Input key="stake" variant={projTheme.input?.defaultVariant ?? "bordered"} label="Max Stake Batch Size" labelPlacement="inside" type="number" description="Max number of NFTs to stake at once" value={String(batchSettings.maxBatchStake ?? defaultBatchSettings.maxBatchStake)} onChange={e_3 => handleStakeChange(e_3)} /></div><div className="flex w-full flex-wrap md:flex-nowrap gap-4"><Input key="unstake" variant={projTheme.input?.defaultVariant ?? "bordered"} label="Max Unstake Batch Size" labelPlacement="inside" type="number" description="Max number of NFTs to unstake at once" value={String(batchSettings.maxBatchUnstake ?? defaultBatchSettings.maxBatchUnstake)} onChange={e_4 => handleUnstakeChange(e_4)} /></div></div></ModalBody><ModalFooter><Popover><PopoverTrigger><Button radius="full" aria-description="Extra info help text">Help!</Button></PopoverTrigger><PopoverContent><div className="px-1 py-2"><div className="text-small font-bold">Select how many NFT's to Mint</div><div className="text-small font-bold">Then press "Mint" to Continue</div></div></PopoverContent></Popover><Button color="success" onPress={() => {
            onClose();
          }} aria-description="Save User Settings">Save</Button></ModalFooter></>}</ModalContent>;
    $[13] = batchSettings.maxBatchClaim;
    $[14] = batchSettings.maxBatchStake;
    $[15] = batchSettings.maxBatchUnstake;
    $[16] = handleClaimChange;
    $[17] = handleStakeChange;
    $[18] = handleUnstakeChange;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isSettingsOpen || $[21] !== onSettingsOpenChange || $[22] !== t7) {
    t8 = <Modal isOpen={isSettingsOpen} onOpenChange={onSettingsOpenChange} backdrop="blur" placement="center" scrollBehavior="inside" className={t5} classNames={t6}>{t7}</Modal>;
    $[20] = isSettingsOpen;
    $[21] = onSettingsOpenChange;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}